var map = {
	"./1.png": "f7d6",
	"./2.png": "3e88",
	"./3.png": "e251",
	"./4.png": "5235",
	"./5.png": "7df9",
	"./6.png": "045e",
	"./7.png": "c7c0",
	"./8.png": "2825"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31cf";